var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20.5C40 31.5457 31.0457 40.5 20 40.5C8.95431 40.5 0 31.5457 0 20.5C0 9.45431 8.95431 0.5 20 0.5C31.0457 0.5 40 9.45431 40 20.5ZM20 10.5C18.6615 10.5 17.6156 11.6557 17.7488 12.9876L18.6256 21.7562C18.6962 22.4623 19.2904 23 20 23C20.7096 23 21.3038 22.4623 21.3744 21.7562L22.2512 12.9876C22.3844 11.6557 21.3385 10.5 20 10.5ZM20.0039 25.5C18.6231 25.5 17.5039 26.6193 17.5039 28C17.5039 29.3807 18.6231 30.5 20.0039 30.5C21.3846 30.5 22.5039 29.3807 22.5039 28C22.5039 26.6193 21.3846 25.5 20.0039 25.5Z",
    fill: "#CC334C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExclamationRed);
export default __webpack_public_path__ + "static/media/ico-exclamation_red.163a5002c072483ccb6a6ce5e636db91.svg";
export { ForwardRef as ReactComponent };